export default __webpack_public_path__ + "static/article-shop-for-christmas-on-a-budget-b5c5a5041243f3c112a76d7621daf9b8.jpg";